import { SendMessageToAppType } from '@customTypes/Webview';

export const sendMessageToApp = (message: SendMessageToAppType): void => {
  if (window.ReactNativeWebView) {
    const webView = window.ReactNativeWebView;
    webView.postMessage(JSON.stringify(message));
  }
};
